import { env } from '@shared/config';
import { maskSensitive } from '@shared/lib/logger';

/**
 * 분석 이벤트. 지연 초기화 싱글턴이다.
 * - 키가 없거나 전송 수단이 등록되지 않았으면 no-op
 * - 이벤트 이름은 P2 의 MET 정의와 같아야 한다
 * - prod 가 아니면 이름 앞에 환경을 붙인다(`dev:report_opened`)
 */
export interface AnalyticsEvent {
  name: string;
  properties: Record<string, unknown>;
  /** ISO 8601 UTC */
  timestamp: string;
}

export type AnalyticsTransport = (event: AnalyticsEvent, key: string) => void;

export interface AnalyticsOptions {
  key: string | undefined;
  env: string;
  transport?: AnalyticsTransport;
}

export function createAnalytics(options: AnalyticsOptions) {
  let transport: AnalyticsTransport | undefined = options.transport;

  return {
    get enabled() {
      return Boolean(options.key && transport);
    },
    /** 분석 도구를 정하면 app 레이어가 부팅 때 등록한다. */
    setTransport(next: AnalyticsTransport) {
      transport = next;
    },
    track(name: string, properties: Record<string, unknown> = {}) {
      try {
        if (!options.key || !transport) return;
        transport(
          {
            name: options.env === 'prod' ? name : `${options.env}:${name}`,
            properties: maskSensitive(properties) as Record<string, unknown>,
            timestamp: new Date().toISOString(),
          },
          options.key,
        );
      } catch {
        // 분석 실패가 화면을 깨지 않게 한다.
      }
    },
  };
}

export type Analytics = ReturnType<typeof createAnalytics>;

export const analytics: Analytics = createAnalytics({ key: env.analyticsKey, env: env.appEnv });
